import MinimalLexical from './LexicalText/MinimalLexical';

export default function TaulukkoFooter({ taulukkoNum, kohdeId, caption, onChange, label }) {
  // lexicalId is always derived from kohdeId, never taken from a stored
  // caption object as-is — MinimalLexical only re-hydrates once per mount
  // (see its HydratePlugin), so remounting on a kohdeId change (e.g.
  // switching rakenneosa/tarkastuskohde) is what makes a freshly-loaded
  // caption actually show up instead of leaving the previous one's text on
  // screen. A caption object that already carries its own lexicalId (v1's
  // shape) is unaffected, since kohdeId is what it was derived from too.
  const lexicalId = (kohdeId ?? 'footer') + '-cap';
  const capData = (() => {
    if (!caption) return { value: '', html: '', lexicalId };
    if (typeof caption === 'string') return { value: caption, html: '', lexicalId };
    return { ...caption, lexicalId };
  })();

  return (
    <div style={{ marginTop: 18, borderTop: '1px solid #dee2e6', paddingTop: 10 }}>
      <div style={{ fontWeight: 700, fontSize: '0.88rem', marginBottom: 4, color: '#495057' }}>
        Taulukko {taulukkoNum}.{label && <span style={{ fontWeight: 400, color: '#6c757d', marginLeft: 6 }}>({label})</span>}
      </div>
      <MinimalLexical
        key={capData.lexicalId}
        data={capData}
        onChange={onChange}
        placeholder="Taulukon kuvaus…"
        plainPaste
      />
    </div>
  );
}
